import { Instant } from '@js-joda/core';
import { DataEntitiesReportsReportType, ServerTransferRecurringReportScheduleResponse, ServerTransferSavedReportResponse } from '../shared/api/axios-client';

export const parseInstant = (dateStr: string | null | undefined): Instant | null => {
    if (!dateStr) return null;
    try {
        const normalizedDate = dateStr.endsWith('Z') || /[+-]\d{2}:?\d{2}$/.test(dateStr) 
            ? dateStr 
            : `${dateStr}Z`;
        return Instant.parse(normalizedDate);
    } catch (e) {
        console.error('Error parsing date:', e, dateStr);
        return null;
    }
};

export const getClientTimezone = (): string => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
        console.error('Error getting client timezone:', e);
        return 'UTC';
    }
};

export enum reportTypes {
  payment = 0,
  subscription = 1,
  aging = 2,
  redeemedvalidation = 3,
  /** Matches `Data.Entities.Reports.ReportType.Custom` */
  custom = 4,
  payoutsummary = 5,
}

export const getReportTypeEnum = (type: string): DataEntitiesReportsReportType => {
  const key = type.trim().toLowerCase() as keyof typeof reportTypes;
  return (reportTypes[key] ?? reportTypes.payment) as DataEntitiesReportsReportType;
};

export type FacilityReportsIndexResponse = {
  savedReports: ServerTransferSavedReportResponse[];
  recurringReports: ServerTransferRecurringReportScheduleResponse[];
};

export function partitionFacilitySavedReports(
  savedReports: ServerTransferSavedReportResponse[],
): [
  ServerTransferSavedReportResponse[],
  ServerTransferSavedReportResponse[],
  ServerTransferSavedReportResponse[],
  ServerTransferSavedReportResponse[],
] {
  const byType = (type: reportTypes) => savedReports.filter((r) => r.type === type);
  return [
    byType(reportTypes.payment),
    byType(reportTypes.subscription),
    byType(reportTypes.aging),
    byType(reportTypes.redeemedvalidation),
  ];
}

export const reportTypeLabels: Record<number, string> = {
  [reportTypes.payment]: "Payment",
  [reportTypes.subscription]: "Subscription",
  [reportTypes.aging]: "Aging",
  [reportTypes.redeemedvalidation]: "Redeemed Validation",
  [reportTypes.custom]: "Custom",
  [reportTypes.payoutsummary]: "Payout Summary",
};